import * as bootstrap from 'bootstrap';
window.Modal = bootstrap.Modal;
import htmx from 'htmx.org';
window.htmx = htmx;
